export const REQUEST_TFR_TEMPLATE = 'dt/tfrTemplates/REQUEST_TFR_TEMPLATE';
export const ADD_TFR_TEMPLATE = 'dt/tfrTemplates/ADD_TFR_TEMPLATE';
export const UPDATE_TFR_TEMPLATE = 'dt/tfrTemplates/UPDATE_TFR_TEMPLATE';
export const DELETE_TFR_TEMPLATE = 'dt/tfrTemplates/DELETE_TFR_TEMPLATE';
export const RECEIVE_TFR_TEMPLATES = 'dt/tfrTemplates/RECEIVE_TFR_TEMPLATES';
export const REMOVE_TFR_TEMPLATE = 'dt/tfrTemplates/REMOVE_TFR_TEMPLATE';

export const requestTfrTemplates = (query) => ({
  type: REQUEST_TFR_TEMPLATE,
  query,
});

export const createTfrTemplate = (payload, callback) => ({
  type: ADD_TFR_TEMPLATE,
  payload,
  callback,
});

export const updateTfrTemplate = (templateId, payload, callback) => ({
  type: UPDATE_TFR_TEMPLATE,
  templateId,
  payload,
  callback,
});

export const deleteTfrTemplate = (templateId, callback) => ({
  type: DELETE_TFR_TEMPLATE,
  templateId,
  callback,
});

export const receiveTfrTemplates = (tfrTemplates) => ({
  type: RECEIVE_TFR_TEMPLATES,
  tfrTemplates,
});

export const removeTfrTemplate = (templateId) => ({
  type: REMOVE_TFR_TEMPLATE,
  templateId,
});
